// @flow
import React, { Fragment, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  StatementsLayout,
  StatementInfo,
  StatementAction,
  StatementNew,
  StatementsList,
  StatementsDataContainer,
} from 'app/components/Statements';

import * as sendUsSections from './sendUsSections';

/**
 *  Страница раздела помощи для отправки сообщения и просмотра списка сообщений
 *  Временное решение, основанное на родительском контроле
 */

type Props = {
  push: (path: string) => void,
  section: string,
  messageId: string,
}

const SendUsMessage = ({ push, section, messageId }: Props) => {
  const { t } = useTranslation('help');

  const baseUrl = '/assistance';

  const handleAddNew = useCallback(() => {
    push(`${baseUrl}/${sendUsSections.EDIT}/new`);
  }, [push]);

  const handleChangeCurrentStatement = useCallback((newStatementId: number) => {
    push(`${baseUrl}/${sendUsSections.VIEW}/${newStatementId}`);
  }, [push]);

  const handleFormCancel = useCallback(() => {
    push(`${baseUrl}/${sendUsSections.VIEW}`);
  }, [push]);


  return (
    <Fragment>
      <h1>{t('send_us_message_header', 'Напишите нам обращение')}</h1>
      <StatementsDataContainer>
        <StatementsLayout
          sideTop={
            <StatementAction
              onClick={handleAddNew}
              disabled={section === sendUsSections.EDIT}
            />
          }
          sideMain={
            <StatementsList
              disabled={section === sendUsSections.EDIT}
              currentStatementId={messageId}
              onCurrentStatementInvalidate={handleChangeCurrentStatement}
              onStatementClick={handleChangeCurrentStatement}
            />
          }
        >
          {section === sendUsSections.VIEW
            && !!messageId
            && <StatementInfo statementId={parseInt(messageId, 10)} />}
          {section === sendUsSections.EDIT
            && messageId === 'new'
            && <StatementNew onCancel={handleFormCancel} />}
        </StatementsLayout>
      </StatementsDataContainer>
    </Fragment>
  );
};

export default SendUsMessage;
